<template>
 
  <!--新闻动态-->
  <div class="news_layout">
    <template v-if="showList && showList.length > 0">
        <div class="news_list_box news_height_3">
          <div v-if="showList[0]" class="n_list_4 news_hover" @click="toDetailPage(showList[0].messageId)">
              <img :src="showList[0].msgUrl" @error="setDefaultImage">
              <div class="in_news_hover_bg">
              <div class="news_hover_title">{{showList[0].title}}</div>
              <div class="news_hover_word">{{showList[0].secondTitle}}</div>
              <i class="iconfont icon-website-xiangyou"></i>
              </div>
          </div>
          <div v-if="showList[1]" class="n_list_4 news_hover" @click="toDetailPage(showList[1].messageId)">
            <img :src="showList[1].msgUrl" @error="setDefaultImage">
              <div class="in_news_hover_bg">
                <div class="news_hover_title">{{showList[1].title}}</div>
                <div class="news_hover_word">{{showList[1].secondTitle}}</div>
                <i class="iconfont icon-website-xiangyou"></i>
              </div>
            </div>
          </div>
          <div class="news_list_box news_height_2" v-if="showList[2]">
            <div v-if="showList[2]" class="n_list_3 news_hover" @click="toDetailPage(showList[2].messageId)">
                <img :src="showList[2].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[2].title}}</div>
                  <div class="news_hover_word">{{showList[2].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
            <div v-if="showList[3]" class="n_list_3 news_hover" @click="toDetailPage(showList[3].messageId)">
                <img :src="showList[3].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[3].title}}</div>
                  <div class="news_hover_word">{{showList[3].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
            <div v-if="showList[4]" class="n_list_3 news_hover" @click="toDetailPage(showList[4].messageId)">
                <img :src="showList[4].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[4].title}}</div>
                  <div class="news_hover_word">{{showList[4].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
          </div>
          <div class="news_list_box news_height_3" v-if="showList[5]">
            <div v-if="showList[5]" class="n_list_4 news_hover" @click="toDetailPage(showList[5].messageId)">
                <img :src="showList[5].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[5].title}}</div>
                  <div class="news_hover_word">{{showList[5].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
            <div v-if="showList[6]" class="n_list_4 news_hover" @click="toDetailPage(showList[6].messageId)">
                <img :src="showList[6].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[6].title}}</div>
                  <div class="news_hover_word">{{showList[6].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
          </div>
          <div class="news_list_box news_height_2" v-if="showList[7]">
            <div v-if="showList[7]" class="n_list_3 news_hover" @click="toDetailPage(showList[7].messageId)">
                <img :src="showList[7].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[7].title}}</div>
                  <div class="news_hover_word">{{showList[7].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
            <div v-if="showList[8]" class="n_list_3 news_hover" @click="toDetailPage(showList[8].messageId)">
                <img :src="showList[8].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[8].title}}</div>
                  <div class="news_hover_word">{{showList[8].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
          <div v-if="showList[9]" class="n_list_3 news_hover" @click="toDetailPage(showList[9].messageId)">
              <img :src="showList[9].msgUrl" @error="setDefaultImage">
              <div class="in_news_hover_bg">
                <div class="news_hover_title">{{showList[9].title}}</div>
                <div class="news_hover_word">{{showList[9].secondTitle}}</div>
                <i class="iconfont icon-website-xiangyou"></i>
              </div>
          </div>
        </div>
          <div class="news_list_box news_height_3" v-if="showList[10]">
            <div v-if="showList[10]" class="n_list_4 news_hover" @click="toDetailPage(showList[10].messageId)">
                <img :src="showList[10].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[10].title}}</div>
                  <div class="news_hover_word">{{showList[10].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
            <div v-if="showList[11]" class="n_list_4 news_hover" @click="toDetailPage(showList[11].messageId)">
                <img :src="showList[11].msgUrl" @error="setDefaultImage">
                <div class="in_news_hover_bg">
                  <div class="news_hover_title">{{showList[11].title}}</div>
                  <div class="news_hover_word">{{showList[11].secondTitle}}</div>
                  <i class="iconfont icon-website-xiangyou"></i>
                </div>
            </div>
          </div>
          
    </template>
    <template v-else>
        <div class="nothing">
            <!-- <img src="../../../assets/img/nothing.png"> -->
            <div class="no_word">暂无内容哦</div>
        </div>
    </template>
    
    <div class="web_fenye" v-if="showList && showList.length > 0">
      <paginate
        :pageCount="pageCount"
        :containerClass="'pagination'"
        :page-range="3"
        :clickHandler="pageClick"
        :first-last-button="false"
        first-button-text="<<"
        last-button-text=">>"
        :prevText="'<'"
        :nextText="'>'"
      >
      </paginate>
    </div>
   
  </div>
       
</template>

<script>
import defaultImage from '../../../assets/img/default_img.png'
export default {
  name: 'ImageTitleListView',
  components:{},
  props: {
    titleName:{
      type:String,
      default:''
    },
    messageList:{
      type:Array,
      default:[]
    },
    perPage:{
      type:Number,
      default:1
    },
    detailRouter:{
      type:String,
      default:''
    },
  },

  data () {
    return {
      
      showList:[],
      totalNum:0,
      pageCount:1,
      
    }
  },
  watch:{
    messageList(val){
        this.messageList = val;
        this.loadData();
    },
  },
  methods:{
    toDetailPage(messageId){
      
      let url = this.$router.resolve({
         name: this.detailRouter,
         query: {detailId:messageId}
       });
       this.$PageUtil.openNewPage(this,url.href)
       
    },
    setDefaultImage(e){
      e.target.src = defaultImage
    },
    pageClick(num){
      this.showList = this.$PageUtil.getStaticPage(num,this.perPage,this.messageList)
    },
    loadData(){
      
      this.totalNum = this.messageList.length;
      this.pageCount = this.$PageUtil.getPageCount(this.totalNum,this.perPage);
      //获得第一页数据
      this.showList = this.$PageUtil.getStaticPage(1,this.perPage,this.messageList);
    },
  },
  mounted(){
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less"> 

    
</style>
